import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const badPermissionsRoute: RouteConfig<'with-page'> = {
    name: 'Error - Bad Permissions',
    path: '/error/bad-permissions',
    page: lazy(() => import('.')),
}